import { render, staticRenderFns } from "./create-call.vue?vue&type=template&id=0d4137a8&scoped=true"
import script from "./create-call.vue?vue&type=script&lang=js"
export * from "./create-call.vue?vue&type=script&lang=js"
import style0 from "./create-call.vue?vue&type=style&index=0&id=0d4137a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4137a8",
  null
  
)

export default component.exports